<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1">
      
      <!-- Header -->
      <div class="row mb-4">
        <div class="col-12 text-center">
          <h4 class="text-primary fw-bold mb-2">
            <i class="fas fa-credit-card me-2"></i>
            Gestión de Métodos de Pago
          </h4>
          <p class="text-muted">
            Controla las opciones de pago disponibles en la aplicación móvil
          </p>
          
          <!-- Actions -->
          <div class="mt-2">
            <!-- COMENTADO: Botón para crear nueva payment option -->
            <!--
            <button 
              type="button" 
              class="btn btn-primary me-2"
              (click)="openCreateModal()"
              [disabled]="loading"
            >
              <i class="fas fa-plus me-1"></i>
              Nueva Payment Option
            </button>
            -->
            <button 
              type="button" 
              class="btn btn-sm btn-outline-primary"
              (click)="loadPaymentOptions()"
              [disabled]="loading"
            >
              <i class="fas fa-sync-alt me-1"></i>
              Recargar
            </button>
            <a
              *ngIf="canSeeAccountsByContract"
              routerLink="/console/perfil-bancario"
              [queryParams]="{ pestana: 'cuentas' }"
              class="btn btn-sm btn-outline-primary ms-2"
            >
              <i class="fas fa-university me-1"></i>
              Cuentas por contrato
            </a>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="text-muted mt-2">Cargando opciones de pago...</p>
      </div>

      <!-- Payment Options List -->
      <div *ngIf="!loading && paymentOptions.length > 0" class="row">
        <div class="col-12">
          
          <!-- Payment Option Card -->
          <div 
            *ngFor="let option of paymentOptions; let i = index" 
            class="card payment-option-card mb-4 border-0 shadow-sm"
            [class.card-active]="isPaymentOptionActive(option)"
            [class.card-inactive]="!isPaymentOptionActive(option)"
          >
            <div class="card-body p-4">
              <div class="row align-items-center">
                
                <!-- Icon and Info -->
                <div class="col-12 col-md-6">
                  <div class="d-flex align-items-start">
                    <div class="payment-icon me-3">
                      <span class="fs-2">{{ getPaymentOptionIcon(option.code) }}</span>
                    </div>
                    <div class="payment-info">
                      <h5 class="card-title mb-1 fw-bold text-dark">
                        {{ option.paymentTitle }}
                      </h5>
                      <p class="card-text text-muted mb-2">
                        {{ option.paymentDescription }}
                      </p>
                      <div class="d-flex align-items-center flex-wrap gap-2">
                        <span 
                          class="badge me-2"
                          [class]="getStatusBadgeClass(option)"
                        >
                          {{ getStatusText(option) }}
                        </span>
                        <div class="priority-info">
                          <small class="text-muted">
                            <i class="fas fa-sort-numeric-up me-1"></i>
                            Prioridad: {{ getCurrentPosition(option) }}
                          </small>
                          <span *ngIf="isPaymentOptionActive(option)" class="badge badge-info ms-2">
                            Posición {{ getCurrentPosition(option) }} de {{ getActivePaymentOptionsCount() }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Actions -->
                <div class="col-12 col-md-6 mt-3 mt-md-0">
                  <div class="d-flex justify-content-md-end justify-content-start flex-wrap gap-2">
                    
                    <!-- Priority Controls (Solo para opciones activas) -->
                    <div *ngIf="isPaymentOptionActive(option)" class="d-flex gap-1">
                      <button 
                        type="button" 
                        class="btn btn-outline-primary btn-sm"
                        [disabled]="!canMoveUp(option) || loading"
                        (click)="moveUp(option)"
                        title="Subir prioridad"
                      >
                        <i class="fas fa-arrow-up"></i>
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-outline-primary btn-sm"
                        [disabled]="!canMoveDown(option) || loading"
                        (click)="moveDown(option)"
                        title="Bajar prioridad"
                      >
                        <i class="fas fa-arrow-down"></i>
                      </button>
                    </div>
                    
                    <!-- Edit Button -->
                    <button 
                      type="button" 
                      class="btn btn-outline-primary btn-sm"
                      (click)="openEditModal(option)"
                      [disabled]="loading || !canEdit()"
                      [title]="canEdit() ? 'Editar' : 'Solo usuarios OWNER pueden editar'"
                    >
                      <i class="fas fa-edit me-1"></i>
                      Editar
                    </button>
                    
                    <!-- Toggle Button -->
                    <button 
                      type="button" 
                      class="btn btn-outline-primary btn-sm"
                      (click)="togglePaymentOption(option)"
                      [disabled]="loading || !canToggle()"
                      [title]="canToggle() ? (isPaymentOptionActive(option) ? 'Desactivar' : 'Activar') : 'Solo usuarios OWNER pueden cambiar el estado'"
                    >
                      <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                      <i *ngIf="!loading"
                        [class.fas]="true"
                        [class.fa-play]="!isPaymentOptionActive(option)"
                        [class.fa-pause]="isPaymentOptionActive(option)"
                        class="me-1">
                      </i>
                      {{ isPaymentOptionActive(option) ? 'Desactivar' : 'Activar' }}
                    </button>

                    <!-- Manage Accounts Button -->
                    <button 
                      type="button"
                      class="btn btn-outline-primary btn-sm me-2"
                      (click)="manageAccounts(option)"
                    >
                      <i class="fas fa-cogs me-1"></i>
                      Gestionar Cuentas
                    </button>

                    <!-- BDV Async Button (simple) -->
                    <button 
                      *ngIf="option.code === 'BOTON_PAGOS_VENEZUELA'"
                      type="button"
                      class="btn btn-outline-danger btn-sm"
                      (click)="manageAsyncBDV(option)"
                    >
                      <i class="fas fa-sync-alt me-1"></i>
                      Gestión Async
                    </button>

                    <!-- COMENTADO: Botón para eliminar payment option -->
                    <!--
                    <button 
                      type="button" 
                      class="btn btn-outline-danger btn-sm"
                      (click)="deletePaymentOption(option)"
                      [disabled]="loading || !canEdit()"
                      [title]="canEdit() ? 'Eliminar' : 'Solo usuarios OWNER pueden eliminar'"
                    >
                      <i class="fas fa-trash me-1"></i>
                      Eliminar
                    </button>
                    -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && paymentOptions.length === 0" class="text-center py-5">
        <div class="empty-state">
          <i class="fas fa-credit-card fa-3x text-muted mb-3"></i>
          <h5 class="text-muted">No hay opciones de pago configuradas</h5>
          <p class="text-muted">
            Las opciones de pago se configuran a nivel de sistema.
          </p>
          <!-- COMENTADO: Botón para crear primera payment option -->
          <!--
          <button 
            type="button" 
            class="btn btn-primary mt-3"
            (click)="openCreateModal()"
            *ngIf="canEdit()"
          >
            <i class="fas fa-plus me-2"></i>
            Crear Primera Payment Option
          </button>
          -->
        </div>
      </div>

      <!-- Info Footer -->
      <div class="row mt-4">
        <div class="col-12">
          <div class="alert alert-info border-0 bg-light">
            <div class="d-flex align-items-start">
              <i class="fas fa-info-circle text-info me-2 mt-1"></i>
              <div>
                <strong>Información importante:</strong>
                <ul class="mb-0 mt-1">
                  <li>Los cambios se reflejan inmediatamente en la aplicación móvil</li>
                  <li>Desactivar una opción oculta todas sus cuentas asociadas</li>
                  <li>El orden de prioridad determina cómo aparecen en la app</li>
                  <li>Solo usuarios con perfil OWNER pueden editar y desactivar opciones</li>
                  <li *ngIf="!canEdit()" class="text-warning">
                    <strong>Tu perfil actual no permite modificar opciones de pago</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Modal para Crear/Editar Payment Option -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" 
     tabindex="-1" role="dialog" aria-labelledby="paymentOptionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white">
        <h5 class="modal-title" id="paymentOptionModalLabel">
          <i class="fas fa-credit-card me-2"></i>
          {{ isEditing ? 'Editar Opción de Pago' : 'Nueva Opción de Pago' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="closeModal()" aria-label="Close"></button>
      </div>
      
      <div class="modal-body">
        <form (ngSubmit)="savePaymentOption()" #paymentForm="ngForm">
          
          <!-- Código -->
          <div class="mb-3">
            <label for="code" class="form-label fw-bold">
              <i class="fas fa-code me-2"></i>Código *
            </label>
            <input 
              type="text" 
              class="form-control"
              id="code"
              name="code"
              [(ngModel)]="paymentOptionForm.code"
              [class.is-invalid]="formErrors['code']"
              [disabled]="isEditing"
              placeholder="Ej: BOTON_PAGOS_NUEVO"
              maxlength="50"
              style="text-transform: uppercase;"
            >
            <div class="form-text">
              Solo letras mayúsculas, números y guiones bajos. {{ isEditing ? '(No se puede modificar)' : '' }}
            </div>
            <div *ngIf="formErrors['code']" class="invalid-feedback">
              {{ formErrors['code'] }}
            </div>
          </div>

          <!-- Nombre -->
          <div class="mb-3">
            <label for="name" class="form-label fw-bold">
              <i class="fas fa-tag me-2"></i>Nombre *
            </label>
            <input 
              type="text" 
              class="form-control"
              id="name"
              name="name"
              [(ngModel)]="paymentOptionForm.name"
              [class.is-invalid]="formErrors['name']"
              placeholder="Ej: Botón de Pagos Nuevo"
              maxlength="100"
            >
            <div class="form-text">
              Nombre interno para identificar la opción de pago
            </div>
            <div *ngIf="formErrors['name']" class="invalid-feedback">
              {{ formErrors['name'] }}
            </div>
          </div>

          <!-- Título de Pago -->
          <div class="mb-3">
            <label for="paymentTitle" class="form-label fw-bold">
              <i class="fas fa-heading me-2"></i>Título de Pago *
            </label>
            <input 
              type="text" 
              class="form-control"
              id="paymentTitle"
              name="paymentTitle"
              [(ngModel)]="paymentOptionForm.paymentTitle"
              [class.is-invalid]="formErrors['paymentTitle']"
              placeholder="Ej: Transferencia Bancaria"
              maxlength="100"
            >
            <div class="form-text">
              Título que verán los usuarios en la aplicación móvil
            </div>
            <div *ngIf="formErrors['paymentTitle']" class="invalid-feedback">
              {{ formErrors['paymentTitle'] }}
            </div>
          </div>

          <!-- Descripción -->
          <div class="mb-3">
            <label for="paymentDescription" class="form-label fw-bold">
              <i class="fas fa-align-left me-2"></i>Descripción *
            </label>
            <textarea 
              class="form-control"
              id="paymentDescription"
              name="paymentDescription"
              [(ngModel)]="paymentOptionForm.paymentDescription"
              [class.is-invalid]="formErrors['paymentDescription']"
              placeholder="Ej: Realiza pagos mediante transferencia bancaria a nuestras cuentas afiliadas"
              rows="3"
              maxlength="500"
            ></textarea>
            <div class="form-text">
              Descripción que verán los usuarios en la aplicación móvil
            </div>
            <div *ngIf="formErrors['paymentDescription']" class="invalid-feedback">
              {{ formErrors['paymentDescription'] }}
            </div>
          </div>

          <!-- Estado -->
          <div class="mb-3">
            <div class="form-check">
              <input 
                class="form-check-input" 
                type="checkbox" 
                id="showClient"
                name="showClient"
                [(ngModel)]="paymentOptionForm.showClient"
              >
              <label class="form-check-label fw-bold" for="showClient">
                <i class="fas fa-eye me-2"></i>Visible para los clientes
              </label>
            </div>
            <div class="form-text">
              Si está marcado, los usuarios podrán ver y usar esta opción de pago
            </div>
          </div>

        </form>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="formSubmitting">
          <i class="fas fa-times me-1"></i>
          Cancelar
        </button>
        <button type="button" class="btn btn-primary" (click)="savePaymentOption()" [disabled]="formSubmitting">
          <span *ngIf="formSubmitting" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!formSubmitting" class="fas fa-save me-1"></i>
          {{ isEditing ? 'Actualizar' : 'Crear' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div *ngIf="showModal" class="modal-backdrop fade show" (click)="closeModal()"></div> 